import {
  dateSet,
  progressSet,
  passengerSet,
  airportSelected,
  tripTypeSelected,
  flightTypeSelected,
  passformSet,
  nearByAirportSet,
  includedCarrierSet,
  refundableSet,
} from "./formSlice";

export const selectAirport = (key: any, value: any) => (dispatch: any) => {
  dispatch(airportSelected({ key, value }));
};
export const setFlightDate = (payload: any) => (dispatch: any) => {
  dispatch(dateSet(payload));
};
export const setPasseger = (key: any, value: any) => (dispatch: any) => {
  dispatch(passengerSet({ key, value }));
};

export const selectTripType = (payload: any) => (dispatch: any) => {
  dispatch(tripTypeSelected(payload));
};
export const selectFlightType = (payload: any) => (dispatch: any) => {
  dispatch(flightTypeSelected(payload));
};

export const setProgress = (payload: any) => (dispatch: any) => {
  dispatch(progressSet(payload));
};

export const setPassForm = (body: any) => (dispatch: any) => {
  dispatch(passformSet(body));
};

export const nearByAirprtToggle = () => (dispatch: any) => {
  dispatch(nearByAirportSet());
};

export const setIncludedAirport = (payload: any) => (dispatch: any) => {
  dispatch(includedCarrierSet(payload));
};

export const setRefundable = () => (dispatch: any) => {
  dispatch(refundableSet());
};
